import { Link } from 'react-router-dom';
import type { Movie } from '@/types';

interface TrendingPanelProps {
  movies: Movie[];
}

export default function TrendingPanel({ movies }: TrendingPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <div>
          <p className="eyebrow text-[10px] text-primary-500">Trending Now</p>
          <h3 className="mt-1 font-heading text-xl tracking-wide text-foreground-950">近期热门榜单</h3>
        </div>
        <span className="flex items-center gap-1 rounded-full bg-primary-500/10 px-2.5 py-1 text-[10px] text-primary-500">
          <i className="ri-pulse-line" aria-hidden="true"></i>
          实时热度
        </span>
      </div>

      <ol className="mt-4 divide-y divide-background-200/80">
        {movies.map((movie, index) => (
          <li key={movie.id}>
            <Link to={`/movie/${movie.id}`} className="group flex items-center gap-3 py-3">
              <span
                className={`w-5 shrink-0 font-heading text-xl leading-none ${
                  index < 3 ? 'text-primary-500' : 'text-foreground-500/70'
                }`}
              >
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="h-14 w-10 shrink-0 overflow-hidden rounded bg-background-200">
                <img
                  src={movie.poster}
                  alt={`《${movie.title}》海报缩略图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm text-foreground-900 transition-colors group-hover:text-primary-500">
                  {movie.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
                  <span>{movie.year}</span>
                  <span className="h-1 w-1 rounded-full bg-foreground-500/60" />
                  <span>{movie.genres[0]}</span>
                </span>
              </span>
              <span className="flex shrink-0 items-center gap-0.5 text-xs font-semibold text-primary-500">
                <i className="ri-star-fill text-[10px]" aria-hidden="true"></i>
                {movie.rating.toFixed(1)}
              </span>
            </Link>
          </li>
        ))}
      </ol>

      <Link
        to="/movies?sort=popular"
        className="mt-3 flex items-center justify-center gap-1.5 rounded-md border border-background-300/70 py-2.5 text-xs text-foreground-700 transition-colors hover:border-primary-500/70 hover:text-primary-500"
      >
        查看完整榜单
        <i className="ri-arrow-right-line" aria-hidden="true"></i>
      </Link>
    </div>
  );
}